import TasksView_Settings from "../settings"
import {BUS_SETTINGS_MANAGER_CONFIG_CHANGED} from "../../../../../gd/bus/bus-event-type"
import ViewTemplates from "../../../../../manager/view-templates/view-templates"
import {AppSettingsMode} from "../../../../../manager/app-settings/app-settings"

// const debug = "tasksView_Settings_onTemplateChanged"
const debug = false

export default function tasksView_Settings_onTemplateChanged(settings: TasksView_Settings) {
    // reset inherited project if template is set
    if (settings._templateId) {
        settings._inheritedFromProject = null
    }

    // @ts-ignore
    debug && console.log(debug, 'process', !!settings.autoSaveFunction, settings.autoSave)

    // check if auto-save is enabled and the onAutoSaveSettings function exists
    if (!!settings.autoSaveFunction && settings.autoSave) {
        // store the current config as the reference (_storedAppSettingsConfig)
        settings._storedAppSettingsConfig = settings.configToJSON()

        // trigger the auto-save function to save settings
        settings.autoSaveFunction()

        // clear any locally stored appSettings as they're now saved
        settings.localSettings.appSettings = null
        settings.localSettings.save()
    } else {
        // No auto-save: update only local settings

        // prepare a new appSettings object with only the templateId
        const newAppSettings = settings._templateId
            ? { templateId: settings._templateId }
            : {}

        // collect all settings not stored in the template, as defined in templateIgnoredParams (e.g. 'defaultZoom' for Gantt)
        const appSettingsNotInTemplate = _.pick(settings, settings.templateIgnoredParams)

        // store the template id and any other required settings not covered by the template
        settings.localSettings.appSettings = _.assign({}, newAppSettings, appSettingsNotInTemplate)
        settings.localSettings.save()
    }

    debug && console.log(debug, 'process settings._templateId', settings._templateId)

    // if a template was chosen, load all parameters from the template
    if(settings._templateId) {
        settings._mode = AppSettingsMode.TEMPLATE

        // retrieve the template's appSettings configuration for the current view type and templateId
        const templateAppSettings = new ViewTemplates().getTemplate(settings.systemType, settings._templateId)!.appSettings
        // initialize the settings instance using the template's properties
        settings.initProperties(templateAppSettings)
    }

    gd.bus.triggerEvent(BUS_SETTINGS_MANAGER_CONFIG_CHANGED)
}